import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Users, X } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { DjayAvatar, DjayBubble } from '../../mascot';
import { OnboardingProgress } from './onboarding/OnboardingProgress';
interface JoinClassroomPromptProps {
  onJoin: (joinCode: string) => void;
  onSkip: () => void;
  isLoading?: boolean;
  error?: string;
  embedded?: boolean;
}
export function JoinClassroomPrompt({
  onJoin,
  onSkip,
  isLoading,
  error,
  embedded = false
}: JoinClassroomPromptProps) {
  const [joinCode, setJoinCode] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (joinCode.trim().length === 6) {
      onJoin(joinCode.trim().toUpperCase());
    }
  };
  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length <= 6) {
      setJoinCode(value);
    }
  };
  const formCard = <div className="bg-white rounded-3xl p-8 shadow-xl border border-orange-100 relative overflow-hidden" data-id="element-117">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-orange-400 to-amber-400" data-id="element-118" />

      {embedded && <OnboardingProgress currentStep={1} role="learner" data-id="element-119" />}

      <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-2xl mb-6 mx-auto" data-id="element-120">
        <Users className="w-6 h-6 text-orange-600" data-id="element-121" />
      </div>

      <h2 className="text-2xl font-bold text-center text-gray-900 mb-2" data-id="element-122">
        Word lid van je klas
      </h2>
      <p className="text-center text-gray-600 mb-8" data-id="element-123">
        Vraag je leraar om de 6-cijferige code.
      </p>

      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-124">
        <div data-id="element-125">
          <Input label="Koppelcode" type="text" value={joinCode} onChange={handleCodeChange} placeholder="Bijv. ABC123" className="text-center text-2xl tracking-widest font-mono uppercase" maxLength={6} required disabled={isLoading} data-id="element-126" />
        
          {error && <p className="mt-2 text-sm text-red-600 text-center" data-id="element-127">{error}</p>}
        </div>

        <div className="space-y-3" data-id="element-128">
          <Button type="submit" className="w-full py-6 text-lg" disabled={joinCode.length !== 6 || isLoading} data-id="element-129">
          
            {isLoading ? 'Bezig met koppelen...' : 'Klas in!'}
            {!isLoading && <ArrowRight className="w-5 h-5 ml-2" data-id="element-130" />}
          </Button>

          {!embedded && <Button type="button" variant="secondary" className="w-full" onClick={onSkip} disabled={isLoading} data-id="element-131">
          
              <X className="w-4 h-4 mr-2" data-id="element-132" />
              Sla over voor nu
            </Button>}
        </div>
      </form>
    </div>;
  if (embedded) {
    return formCard;
  }
  return <div className="min-h-screen bg-orange-50 flex flex-col items-center justify-center p-4" data-id="element-133">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-134">
        
        {/* Mascot Section */}
        <div className="flex flex-col items-center mb-8 relative" data-id="element-135">
          <DjayBubble message="Welkom! Heb je een koppelcode van je meester of juf gekregen? Vul hem hier in om in je klas te komen!" variant="welcome" className="mb-4" data-id="element-136" />
          
          <DjayAvatar emotion="excited" size="lg" data-id="element-137" />
        </div>

        {formCard}
      </motion.div>
    </div>;
}